import { createContext } from 'react';

import { availableLanguages } from '@shared/constants/languages';
import { SDK as BaseSDK } from '@shared/theme/types/sdk';

export interface SDK extends Omit<BaseSDK, 'language'> {
  language?: (typeof availableLanguages)[number];
}

interface ContextProps {
  _sdk: SDK | null;
  getSdk: () => SDK | null;
  setSdk: (sdk: SDK) => void;
  sendMessage: (value: string) => void;
}

export const PostMessageContext = createContext<ContextProps>({
  _sdk: null,
  getSdk: () => null,
  setSdk: () => {},
  sendMessage: () => {},
});
